import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["data", "fetchMore"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo, useCallback } from "react";
import dynamic from "next/dynamic";
import List from "@/components/List";
import { useCanvasQuery } from "@/hooks";
import { CANVAS_PAGE_LIMIT } from "@/lib/constants";
import styles from "@/styles/Canvas.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HtmlSnippet = dynamic(() => import("@/components/HtmlSnippet"), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("@/components/HtmlSnippet")]
  }
});
const Palette = dynamic(() => import("@/components/Palette"), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("@/components/Palette")]
  }
});
function CanvasStructure(_ref) {
  let {
    item,
    hiddenPrice
  } = _ref;
  const {
    type,
    id
  } = item;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [type === "palette" && /*#__PURE__*/_jsx(Palette, {
      id: id,
      hiddenPrice: hiddenPrice
    }), type === "html_snippet" && /*#__PURE__*/_jsx(HtmlSnippet, {
      id: id
    })]
  });
}
function Canvas(_ref2) {
  let {
    idKey,
    hiddenPrice,
    title
  } = _ref2;
  const _useCanvasQuery = useCanvasQuery({
      variables: {
        idKey: idKey.toString(),
        offset: 0,
        limit: CANVAS_PAGE_LIMIT
      },
      nextFetchPolicy: "cache-first"
    }),
    {
      data,
      fetchMore
    } = _useCanvasQuery,
    queryResult = _objectWithoutProperties(_useCanvasQuery, _excluded);
  const items = data === null || data === void 0 ? void 0 : data.canvas;
  const itemComponent = useCallback(_ref3 => {
    let {
      item
    } = _ref3;
    return /*#__PURE__*/_jsx(CanvasStructure, {
      item: item,
      hiddenPrice: hiddenPrice
    });
  }, [hiddenPrice]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [title && /*#__PURE__*/_jsx("h1", {
      className: styles.title,
      children: title
    }), /*#__PURE__*/_jsx(List, _objectSpread(_objectSpread({
      items: items,
      limit: CANVAS_PAGE_LIMIT
    }, queryResult), {}, {
      itemComponent: itemComponent,
      fetchMore: fetchMore
    }))]
  });
}
export default /*#__PURE__*/memo(Canvas);